import { ThemeName } from "@ngt/opms";
import { PatientStateType } from "./api/dtos";

// export interface ISentrySettings {
//     dsn?: string;
//     customer: string;
//     environment: string;
//     sendDefaultPii: boolean;
//     enableMetrics: boolean;
//     attachStacktrace: boolean;
//     debug: boolean;
//     application: string;
//     release?: string;
//     replaysSessionSampleRate: number;
//     replaysOnErrorSampleRate: number;
//     enableLogs: boolean;
//     tracesSampleRate: number;
//     enableReportABug: boolean;
// }
export const allStates = [
    PatientStateType.Screening,
    PatientStateType.Consent,
    PatientStateType.OnStudy,
    PatientStateType.ScreeningFailed
]

export interface IAppSettings {
    debug?: boolean;
    trialPortalUrl: string;
    ecrfUrl: string;
    consentInformationUrl: string;
    consentParticipantUrl: string;
    bctEmailAddressMatch: string;
    bctMedicalReviewSharedMailbox: string;
    bannedPasswordUrl: string;
    
    palette: IPaletteSettings;
    client: IClientSettings;
    // sentry: ISentrySettings;
};

export interface IPaletteSettings {
    primaryLight: string;
    secondaryLight: string;
    primaryDark: string;
    secondaryDark: string;
    errorDark: string;
    errorLight: string;
    greenLight: string;
    greenDark: string;
    orangeLight: string;
    orangeDark: string;
    redLight: string;
    redDark: string;
    blueLight: string;
    blueDark: string;
    overrideTheme?: ThemeName;
};

export interface IClientSettings {
    baseUrl?: string;
    basePath?: string;
};

const dayOfYear = (date: Date) => {
    const year = date.getFullYear();
    const month = date.getMonth()+1;
    const day = date.getDate();

    const N1 = Math.floor(275 * month / 9);
    const N2 = Math.floor((month + 9) / 12);
    const N3 = (1 + Math.floor((year - 4 * Math.floor(year / 4) + 2) / 3));
    const N = N1 - (N2 * N3) + day - 30;
    return N;
}

const enableValue = `grade-${dayOfYear(new Date())}`

const params = new URLSearchParams(window.location.search);
export const AppSettings: IAppSettings = {
    debug: import.meta.env.DEV || params.get('debug') === enableValue,
    trialPortalUrl: (window as any).TRIAL_PORTAL_URL ?? import.meta.env.VITE_TRIALPORTAL_BASE_URL,
    ecrfUrl: (window as any).ECRF_URL ?? import.meta.env.VITE_ECRF_BASE_URL,
    consentInformationUrl: (window as any).CONSENT_INFORMATION_URL ?? import.meta.env.VITE_CONSENT_INFORMATION_URL,
    consentParticipantUrl: (window as any).CONSENT_PARTICIPANT_BASE_URL ?? import.meta.env.VITE_CONSENT_PARTICIPANT_BASE_URL,
    bctEmailAddressMatch: (window as any).SAE_NOTIFY?.bctEmailAddressMatch ?? import.meta.env.VITE_BCT_EMAIL_MATCH,
    bctMedicalReviewSharedMailbox: (window as any).SAE_NOTIFY?.bctMedicalReviewSharedMailbox  ?? import.meta.env.VITE_BCT_REVIEW_MAILBOX,
    bannedPasswordUrl: "https://docs.azure.cn/en-us/entra/identity/authentication/concept-password-ban-bad",
    
    client: {
        baseUrl: import.meta.env.VITE_API_URL,
        basePath: '/api'
    },
    palette: {
        // primaryDark: '#7d6699',
        primaryDark: '#57476b',
        primaryLight: '#562c85',
        secondaryDark: '#99567e',
        secondaryLight: '#e8078c',
        // overrideTheme: 'light',
        errorDark: 'rgb(251, 110, 99)',
        errorLight: '#ef5350',
        greenDark: "#3a5c37",
        greenLight: "#9bbd9a",
        orangeDark: "#79491d",
        orangeLight: "#efb485",
        redDark: "#74221f",
        redLight: "#e19798",
        blueDark: "#1e3a8a", 
        blueLight: "#60a5fa"
    },

    
    // sentry: {
    //     dsn: getSentryString('dsn', 'VITE_SENTRY_DSN'),
    //     debug: getSentryBoolean('debug', 'VITE_SENTRY_DEBUG') ?? false,
    //     enableMetrics: getSentryBoolean('enableMetrics', 'VITE_SENTRY_ENABLE_METRICS') ?? false,
    //     sendDefaultPii: getSentryBoolean('sendDefaultPii', 'VITE_SENTRY_SEND_DEFAULT_PII') ?? false,
    //     attachStacktrace: getSentryBoolean('attachStacktrace', 'VITE_SENTRY_ATTACH_STACKTRACE') ?? false,
    //     customer: getSentryString('customer', 'VITE_SENTRY_CUSTOMER') ?? 'Unknown',
    //     environment:  getSentryString('environment', 'VITE_SENTRY_ENVIRONMENT') ?? 'Development',
    //     application: getSentryString(undefined, 'VITE_SENTRY_APPLICATION') ?? 'SourceDataVerification',
    //     release: getSentryString(undefined, 'VITE_SENTRY_RELEASE'),
    //     enableLogs: getSentryBoolean('enableLogs', 'VITE_SENTRY_ENABLE_LOGS') ?? false,
    //     replaysOnErrorSampleRate: getSentryNumber('replaysOnErrorSampleRate', 'VITE_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE') ?? 1.0,
    //     replaysSessionSampleRate: getSentryNumber('replaysSessionSampleRate', 'VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE') ?? 0.1,
    //     tracesSampleRate: getSentryNumber('tracesSampleRate', 'VITE_SENTRY_TRACE_SAMPLE_RATE') ?? 0.2,
    //     enableReportABug: getSentryBoolean('enableReportABug', 'VITE_SENTRY_ENABLE_REPORT_A_BUG') ?? false
    // }
};
